import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortDatabaseComponent } from './port-database.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { ChartModule } from 'angular-highcharts';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { ExpansionPanelModule } from 'src/app/shared/components/expansion-panel/expansion-panel.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { MatDialogModule } from '@angular/material/dialog';
import { PortDatabaseRoutingModule } from './port-database-routing.module';
import { PcMultiSelectFilterModule } from 'src/app/shared/components/pc-multi-select-filter/pc-multi-select-filter.module';
import { PortDeleteConfirmPopupModule } from '../port-delete-confirm-popup/port-delete-confirm-popup.module';



@NgModule({
  declarations: [
    PortDatabaseComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    MatPaginatorModule,
    MatSortModule,
    FormsModule,
    CustomDatePickerModule,
    CustomInputModule,
    CustomDropdownModule,
    ExpansionPanelModule,
    ChartModule,
    MatDialogModule,
    PortDatabaseRoutingModule,
    PcMultiSelectFilterModule,
    PortDeleteConfirmPopupModule,
  ],
  exports:[
    PortDatabaseComponent
  ]
})
export class PortDatabaseModule { }
